import { DateTime } from "luxon";

import { AnalyzeSitewideRequestBodyType } from "@intelligems/ig-types";

export type ISitewideDashboardFilters = Omit<
  AnalyzeSitewideRequestBodyType,
  "datasetId"
>;
export const initialSitewideDashboardFiltersState: ISitewideDashboardFilters = {
  resourceType: "sitewide",
  period: "week",
  startTime: DateTime.now().minus({ days: 30 }).startOf("day").toMillis(),
  endTime: DateTime.now().toMillis(),
  deviceType: null,
  visitorType: null,
  channels: [],
  countryCodes: [],
  shippingExpensePerOrder: null,
  transactionFeePct: null,
  subscriptionType: null,
  urlParam: {
    queryParam: null,
    queryParamValue: null,
    queryParamFilterType: null,
  },
};

export type SitewideDashboardFiltersDialog = Omit<
  ISitewideDashboardFilters,
  "period"
>;
